import { Skeleton } from '@mui/material';
import React, { Fragment, useState, useEffect } from 'react';

import BarChart from './BarChart';
import requestApi from "../../../services/requestApi.service";
import FunnelChart from './FunnelChart';
import PieChart from './PieChart';
import TableChart from './TableChart';

const GraphChart = (props) => {
    let { dashboard, isNeedRefresh, user } = props;
    let [dashboardData, setDashboardData] = useState([]);
    let [chartContent, setChartContent] = useState([]);
    let dashboardId = dashboard[0];
    let dashboardName = dashboard[1];
    let dashboardType = parseInt(dashboard[2]);
    let dbType = parseInt(dashboard[3]);
    let entityType = parseInt(dashboard[4]);
    useEffect(() => {
        (async () => {
            if (dashboard.length > 0) {
                await prepareDashboardData();
            }
        })();
        return () => {
            // this now gets called when the component unmounts
        };

    }, [dashboard]);

    const prepareDashboardData = async () => {
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "DASHBOARDPREVIEW",
            "FORMNAME": "",
            "MODULENAME": "",
            "FORMTYPE": "",
            "isSearchNeeded" : Object.keys(user).length > 0 ? true : false,
            "SEARCHUSER" : Object.keys(user).length ? user.label : "All Users",
            "dashboardid": dashboardId,
            "needRefreshed": isNeedRefresh !== "",
        }
        let res = await requestApi.processServerRequest(params);
        if (res.issuccess) {
            let data = res.data;
            setDashboardData(data);
            if ((dashboardType === 0 && dbType === 1) || dashboardType === 1) {
                let content = (
                    <div className="scrollable-content">
                      <BarChart dashboard={dashboard} data={data} />
                    </div>
                );
                setChartContent(content);
            } else if (dashboardType === 2) {
                let content = (
                    <div className="scrollable-content">
                      <PieChart dashboard={dashboard} data={data} />
                    </div>
                );
                setChartContent(content);
            } else if (dashboardType === 3) {
                let content = (
                    <div className="scrollable-content">
                        <FunnelChart dashboard={dashboard} data={data} />
                    </div>
                );
                setChartContent(content);
            } else if (dashboardType === 0 && dbType === 0){
                let content = (
                    <div className='scrollable-content'>
                        <TableChart dashboard={dashboard} data={data} />
                    </div>
                );
                setChartContent(content);
            }
        }
    }

    return (
        <div>
            {dashboardName}
            {dashboardData.length > 0 && <Fragment>
                    {chartContent}
                </Fragment>
            }
            {
                dashboardData.length === 0 &&
                <div>
                    <Skeleton animation="wave" height={250} />
                </div>
            }
        </div>
    )
};

export default GraphChart;